import { Navigate, Route } from "react-router-dom";
import CustomerLayout from "./customerLayout";
import { lazyPage } from "../shared/lazyPage";

const CustomerFindCaregivers = lazyPage(() => import("../../pages/CustomerFindCaregivers"));
const CustomerDashboard = lazyPage(() => import("../../pages/CustomerDashboard"));
const Marketplace = lazyPage(() => import("../../pages/Marketplace"));
const HourlyBooking = lazyPage(() => import("../../pages/HourlyBooking"));
const ElderProfile = lazyPage(() => import("../../pages/ElderProfile"));
const CareLogs = lazyPage(() => import("../../pages/CareLogs"));
const CustomerCareTeam = lazyPage(() => import("../../pages/CustomerCareTeam"));
const CallHistory = lazyPage(() => import("../../pages/CallHistory"));
const MyBookings = lazyPage(() => import("../../pages/MyBookings"));
const CustomerPaymentHistory = lazyPage(() => import("../../pages/CustomerPaymentHistory"));
const CustomerBookingCalendar = lazyPage(() => import("../../pages/CustomerBookingCalendar"));
const CustomerProfile = lazyPage(() => import("../../pages/CustomerProfile"));
const CustomerSubscription = lazyPage(() => import("../../pages/CustomerSubscription"));
const CustomerCarePassUpgrade = lazyPage(() => import("../../pages/CustomerCarePassUpgrade"));
const CustomerVerifyKyc = lazyPage(() => import("../../pages/CustomerVerifyKyc"));
const NotificationsPage = lazyPage(() => import("../../pages/NotificationsPage"));
const MessengerPage = lazyPage(() => import("../../pages/MessengerPage"));
const CustomerPayments = lazyPage(() => import("../../pages/CustomerPayments"));
const CustomerMyCareManager = lazyPage(() => import("../../pages/CustomerMyCareManager"));
const CustomerSupportCenter = lazyPage(() => import("../../pages/CustomerSupportCenter"));
const CustomerSettings = lazyPage(() => import("../../pages/CustomerSettings"));

export function renderCustomerRoutes() {
  return (
    <>
      {/* Standalone booking screen: same flow/logic as /marketplace, rendered without the sidebar. */}
      <Route element={<CustomerLayout hideSidebar />}>
        <Route path="/book-care" element={<CustomerFindCaregivers />} />
      </Route>
      <Route element={<CustomerLayout />}>
        <Route path="/customer/verify-kyc" element={<CustomerVerifyKyc />} />
        <Route path="/dashboard" element={<CustomerDashboard />} />
        <Route path="/marketplace" element={<CustomerFindCaregivers />} />
        <Route path="/marketplace/booking" element={<Marketplace />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/payments" element={<CustomerPaymentHistory />} />
        <Route path="/payment-history" element={<CustomerPayments />} />
        <Route path="/my-care-manager" element={<CustomerMyCareManager />} />
        <Route path="/support" element={<CustomerSupportCenter />} />
        <Route path="/settings" element={<CustomerSettings />} />
        <Route path="/my-bookings/calendar" element={<CustomerBookingCalendar />} />
        <Route path="/notifications" element={<NotificationsPage role="CUSTOMER" />} />
        <Route path="/messenger" element={<MessengerPage role="CUSTOMER" />} />
        <Route path="/subscription" element={<CustomerSubscription />} />
        <Route path="/subscription/upgrade" element={<CustomerCarePassUpgrade />} />
        <Route path="/my-agreement" element={<Navigate to="/subscription" replace />} />
        <Route path="/profile" element={<CustomerProfile />} />
        <Route path="/hourly" element={<HourlyBooking />} />
        <Route path="/elder-profile" element={<ElderProfile />} />
        <Route path="/care-team" element={<CustomerCareTeam />} />
        <Route path="/care-logs" element={<CareLogs />} />
        <Route path="/call-history" element={<CallHistory />} />
        {/* Legacy CareHub portal → existing customer screens */}
        <Route path="/carehub" element={<Navigate to="/marketplace" replace />} />
        <Route path="/carehub/search" element={<Navigate to="/marketplace" replace />} />
        <Route path="/carehub/consultations" element={<Navigate to="/my-bookings" replace />} />
        <Route path="/carehub/registry" element={<Navigate to="/elder-profile" replace />} />
      </Route>
    </>
  );
}
